export const EyeCloseIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.68662 6.31328L6.31328 9.68662C5.87995 9.25329 5.61328 8.65995 5.61328 7.99995C5.61328 6.67995 6.67995 5.61328 7.99995 5.61328C8.65995 5.61328 9.25329 5.87995 9.68662 6.31328Z"
        stroke="#485263"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8799 3.84657C10.7132 2.96657 9.37991 2.48657 7.99991 2.48657C5.64657 2.48657 3.45323 3.87324 1.92656 6.27324C1.32656 7.21325 1.32656 8.79325 1.92656 9.73325C2.45323 10.5599 3.06656 11.2733 3.73323 11.8466"
        stroke="#485263"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.61328 13.02C6.37328 13.34 7.17995 13.5133 7.99995 13.5133C10.3533 13.5133 12.5466 12.1266 14.0733 9.72663C14.6733 8.78663 14.6733 7.20662 14.0733 6.26662C13.8533 5.91996 13.6133 5.59329 13.3666 5.28662"
        stroke="#485263"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.34 8.4668C10.1666 9.4068 9.39996 10.1735 8.45996 10.3468"
        stroke="#485263"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.3135 9.68677L1.3335 14.6668"
        stroke="#485263"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6665 1.33325L9.68652 6.31326"
        stroke="#485263"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
